// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Product$Showside from "./Product.bs.js";
import * as UniqueArray$Showside from "../utils/UniqueArray.bs.js";
function getOrder(slide) {
  switch (slide.TAG | 0) {
    case /* Product */0:
      return slide.order;
    case /* Placeholder */1:
    case /* UnloadedProduct */2:
      return slide.order;
  }
}
function setOrder(slide, order) {
  switch (slide.TAG | 0) {
    case /* Product */0:
      return {
        TAG: /* Product */0,
        pinned: slide.pinned,
        product: slide.product,
        variant: slide.variant,
        order: order
      };
    case /* Placeholder */1:
      return {
        TAG: /* Placeholder */1,
        pinned: slide.pinned,
        id: slide.id,
        order: order
      };
    case /* UnloadedProduct */2:
      return {
        TAG: /* UnloadedProduct */2,
        pinned: slide.pinned,
        id: slide.id,
        order: order
      };
  }
}
function getId(slide) {
  switch (slide.TAG | 0) {
    case /* Product */0:
      return slide.product.id;
    case /* Placeholder */1:
    case /* UnloadedProduct */2:
      return slide.id;
  }
}
function isPinned(slide) {
  switch (slide.TAG | 0) {
    case /* Product */0:
    case /* Placeholder */1:
    case /* UnloadedProduct */2:
      return slide.pinned;
  }
}
function isPlaceholder(slide) {
  switch (slide.TAG | 0) {
    case /* Placeholder */1:
      return true;
    case /* Product */0:
    case /* UnloadedProduct */2:
      return false;
  }
}
function makeProductSlide(pinnedOpt, variantId, order, product) {
  var pinned = pinnedOpt !== undefined ? pinnedOpt : false;
  var variant = Belt_Option.getWithDefault(Belt_Option.flatMap(variantId, function (variantId) {
    return Product$Showside.getVariantById(product, variantId);
  }), product.firstVariant);
  return {
    TAG: /* Product */0,
    pinned: pinned,
    product: product,
    variant: variant,
    order: order
  };
}
function makePlaceholderSlide(pinnedOpt, id, order) {
  var pinned = pinnedOpt !== undefined ? pinnedOpt : false;
  return {
    TAG: /* Placeholder */1,
    pinned: pinned,
    id: Belt_Option.getWithDefault(id, "placeholder-" + String(order)),
    order: order
  };
}
function makeUnloadedProductSlide(pinnedOpt, id, order) {
  var pinned = pinnedOpt !== undefined ? pinnedOpt : false;
  return {
    TAG: /* UnloadedProduct */2,
    pinned: pinned,
    id: Belt_Option.getWithDefault(id, "unloaded-" + String(order)),
    order: order
  };
}
function getKey(slide) {
  switch (slide.TAG | 0) {
    case /* Product */0:
      return slide.product.id + "-" + slide.variant.id + "-" + String(slide.order);
    case /* Placeholder */1:
      return "placeholder-" + slide.id + "-" + String(slide.order);
    case /* UnloadedProduct */2:
      return "unloaded-" + slide.id + "-" + String(slide.order);
  }
}
var Slide = {
  getOrder: getOrder,
  setOrder: setOrder,
  getId: getId,
  isPinned: isPinned,
  isPlaceholder: isPlaceholder,
  makeProductSlide: makeProductSlide,
  makePlaceholderSlide: makePlaceholderSlide,
  makeUnloadedProductSlide: makeUnloadedProductSlide,
  getKey: getKey
};
function dedupById(__x) {
  return UniqueArray$Showside.getUnique(__x, getId);
}
var Slides = {
  dedupById: dedupById
};
function getKey$1(config) {
  return Belt_Array.flatMap([Belt_Array.map(config.slides, getKey), [String(config.position)], [String(config.total)]], function (a) {
    return a;
  }).join("-");
}
function trimTrailingPlaceholders(slides) {
  var lastValidIdx = Belt_Option.keep(Belt_Array.map(slides, isPlaceholder).lastIndexOf(false), function (i) {
    return i >= 0;
  });
  if (lastValidIdx !== undefined) {
    return Belt_Array.slice(slides, 0, lastValidIdx + 2 | 0);
  } else {
    return slides;
  }
}
function getActiveProduct(config) {
  return Belt_Option.flatMap(Belt_Array.get(config.slides, config.position), function (slide) {
    switch (slide.TAG | 0) {
      case /* Product */0:
        return slide.product;
      case /* Placeholder */1:
      case /* UnloadedProduct */2:
        return;
    }
  });
}
function getActiveVariant(config) {
  return Belt_Option.flatMap(Belt_Array.get(config.slides, config.position), function (slide) {
    switch (slide.TAG | 0) {
      case /* Product */0:
        return slide.variant;
      case /* Placeholder */1:
      case /* UnloadedProduct */2:
        return;
    }
  });
}
export { Slide, Slides, getKey$1 as getKey, trimTrailingPlaceholders, getActiveProduct, getActiveVariant };
/* Product-Showside Not a pure module */